<template>
  <div class="padded">

    <!-- @TODO fix for assets -->
    <!-- embedded: EquipMaint can render inside the site drawer (equip tab →
         EquipDetails → EquipMaint), so it must NOT mount its own drawer-stack
         (it would mis-parse the ancestor /sites/d.site.X URL). disable-layer
         keeps rows non-clickable until the asset routes get a cascade. -->
    <tickets-table
     :site-id="rowData.site_id"
     :asset-id="assetId"
     :owner-id="rowData.organisation_id"
     process-key="equip-ticket"
     :hide-site="true"
     :disable-layer="true" />

</div>
</template>


<script>

import TicketsTable from '@/components/tables/TicketsTable'

export default {
  components: {
    TicketsTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    assetId: {
      type: Number
    }
  }

}

</script>
